import { memo } from 'react';
import Button from '@material-ui/core/Button';
import { ButtonInterface } from './interface/Button';
import { Container } from '../container/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useCallback } from 'react';

function ButtonComponent({ title, type, size = 'large', disabled, onClick, fullWidth, color, icon, margin, variant, NoReload, sizeFont }: ButtonInterface) {

    const sizeButtom = useCallback((size: "small" | "medium" | "large") => {
        const sizeAux: number = size === 'large' ? 48 : 40;
        return size === 'small' ? 34 : sizeAux;
    }, []);

    return (
        <Container margin={margin}>
            <Button type={type || 'submit'}
                size={'small'}
                variant={variant || 'contained'}
                color={color || 'primary'}
                onClick={onClick}
                fullWidth={fullWidth || false}
                disabled={disabled || false}
                endIcon={((!type || type === 'submit') && disabled && !NoReload) ? <CircularProgress size={20} color='inherit' /> : icon}
                style={{
                    paddingRight: (!!icon || ((!type || type === 'submit') && disabled && !NoReload)) ? 2 : 15,
                    paddingTop: !!icon ? 0 : 4,
                    paddingBottom: !!icon ? 0 : 4,
                    height: sizeButtom(size), borderRadius: 4,
                    paddingLeft: 15,
                    fontSize: sizeFont
                }}
            >
                {((!type || type === 'submit') && disabled && !NoReload) ? 'Salvando' : title.toLocaleUpperCase()}
            </Button>
        </Container >
    );
}

export default memo(ButtonComponent);
